import { Button } from '@shared/components/ui/button';
import { FilterConditionOutput } from '@components/ui/AdvancedFilter';
import { faFileArrowDown, faSpinnerThird } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { useExportOrders } from '../../hooks/useExportOrders';

interface Props {
  filterConditions: FilterConditionOutput[];
  search?: string;
  statusId?: number;
  sorting?: { field: string; direction: 'asc' | 'desc' };
  visibleColumns?: string[];
}

export const DownloadExcelButton: React.FC<Props> = ({
  filterConditions,
  search,
  statusId,
  sorting,
  visibleColumns,
}) => {
  const { t } = useTranslation('ordersModule');
  const { exportOrders, isExporting } = useExportOrders();

  const handleExport = () => {
    exportOrders(filterConditions, search, statusId, sorting, visibleColumns);
  };

  return (
    <Button
      onClick={handleExport}
      disabled={isExporting}
      type="button"
      size="sm"
      variant="outline"
      className="!py-[9px] !px-2 text-foreground/70 hover:text-foreground border-input hover:bg-accent"
      data-testid="export-excel-button"
    >
      {isExporting ? (
        <FontAwesomeIcon icon={faSpinnerThird} className="animate-spin" />
      ) : (
        <FontAwesomeIcon icon={faFileArrowDown} />
      )}
    </Button>
  );
};
